import appStorage from "@/lib/appStorage";
import config from "@/config";
import { fullLocale } from "@/locales";

export function getLocale(): string {
  return appStorage.getString("locale", config.locale);
}
export function getFullLocale(): string {
  return fullLocale[appStorage.getString("locale", config.locale)];
}

interface Locale {
  [k: string]: string | Locale;
}

export function setHtmlLang() {
  document.documentElement.lang = getLocale();
}

export async function loadLocaleMessages(locale: string): Promise<Locale> {
  const messages = await import(/* webpackChunkName: "locale-[request]" */ `@/locales/messages/${locale}.ts`);
  return messages.default as Locale;
}

// three times heavier than the messages and needed only by the location pickers, so kept off the startup path
export function loadLocaleLocations(locale: string): Promise<Locale | undefined> {
  return import(/* webpackChunkName: "locations-[request]" */ `@/locales/locations/${locale}.ts`)
    .then(m => m.default as Locale)
    .catch(() => undefined);
}
